import InputField from "@components/form/InputField";
import ParagraphAnswerEditor from "./ParagraphAnswerEditor";
import AdvancedOptionsEditor from "./AdvancedOptionsEditor";
import QuestionToggles from "./QuestionToggles";

export default function QuestionEditor({ question, onUpdate }) {
  const isAdvanced = ["Multiple Choice", "Checkboxes"].includes(
    question.select
  );

  const isSection =
    question.select === "Section Title" ||
    question.select === "Section Subtitle";

  const isShortAnswerWithPlaceholder =
    question.select === "Short Answer" && question.showPlaceholder;

  return (
    <div className="p-5 space-y-4 border border-gray-200 bg-white dark:bg-gray-800">
      {/* Question or Section Title */}
      <InputField
        label={
          question.select === "Section Title"
            ? "Section Title"
            : question.select === "Section Subtitle"
            ? "Section Subtitle"
            : "Question Label"
        }
        required
        value={isSection ? question.value : question.question}
        onChange={(e) => {
          const newValue = e.target.value;
          const key = isSection ? "value" : "question";
          onUpdate(question.id, { [key]: newValue });
        }}
        placeholder={`(e.g. Patient ${
          question.select === "Date" ? "Birthday" : "Name"
        })`}
      />
      {isShortAnswerWithPlaceholder && (
        <InputField
          label="Question Placeholder"
          required
          value={question.value || ""}
          onChange={(e) => onUpdate(question.id, { value: e.target.value })}
          placeholder="Input your placeholder here..."
        />
      )}

      {/* Paragraph editor */}
      {question.select === "Paragraph" && !question.isParagraphAnswer && (
        <ParagraphAnswerEditor question={question} onUpdate={onUpdate} />
      )}

      {/* Advanced options */}
      {isAdvanced && (
        <AdvancedOptionsEditor question={question} onUpdate={onUpdate} />
      )}

      {/* Toggles */}
      <QuestionToggles question={question} onUpdate={onUpdate} />
    </div>
  );
}
